// =============================================================================
// Profile.tsx — Player profile screen
// Project: Texas Hold'em Social Casino
// =============================================================================
// Shows player stats, VIP status, and account settings.

import React from 'react'
import { useUIStore } from '../store/ui-store'
import { usePlayerStore } from '../store/player-store'

export default function ProfileScreen(): React.ReactElement {
  const { navigateTo } = useUIStore()
  const { profile, token } = usePlayerStore()

  const copyId = (): void => {
    if (token) {
      navigator.clipboard.writeText(token)
      useUIStore.getState().showToast('Player ID copied!', 'success')
    }
  }

  return (
    <div className="lobby">
      <div className="lobby-header">
        <button className="btn btn-secondary" style={{ padding: '6px 14px', fontSize: 12 }} onClick={() => navigateTo('lobby')}>
          ← Back
        </button>
        <div className="lobby-title">Profile</div>
        <div style={{ width: 60 }} />
      </div>

      {profile && (
        <div style={{ marginTop: 16 }}>
          {/* Avatar */}
          <div className="flex-center" style={{ marginBottom: 16 }}>
            <div style={{
              width: 64, height: 64, borderRadius: '50%',
              background: 'linear-gradient(135deg, #e8491d, #f5c518)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 28, fontWeight: 700, color: '#fff',
            }}>
              {profile.name.charAt(0).toUpperCase()}
            </div>
          </div>

          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <div style={{ fontSize: 20, fontWeight: 700 }}>{profile.name}</div>
            <div style={{ fontSize: 14, color: '#f5c518' }}>Level {profile.level}</div>
          </div>

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <StatCard label="Chips" value={profile.chips.toLocaleString()} color="#f5c518" />
            <StatCard label="XP" value={profile.xp.toLocaleString()} color="#1976d2" />
            <StatCard label="Hands Played" value={profile.totalHands.toLocaleString()} color="#888" />
            <StatCard label="Hands Won" value={profile.totalWins.toLocaleString()} color="#4caf50" />
            <StatCard label="VIP Tier" value={`${profile.vipTier}`} color={profile.vipTier > 0 ? '#e8491d' : '#888'} />
          </div>

          {/* Player ID */}
          <div style={{ marginTop: 20 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Player ID</div>
            <div
              onClick={copyId}
              style={{
                fontSize: 11, color: '#888', background: 'rgba(0,0,0,0.3)',
                padding: '8px 12px', borderRadius: 8, cursor: 'pointer',
                fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis',
              }}
            >
              {token}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

function StatCard({ label, value, color }: { label: string; value: string; color: string }): React.ReactElement {
  return (
    <div style={{
      background: 'rgba(255,255,255,0.05)', borderRadius: 12,
      padding: '12px 16px', textAlign: 'center',
      border: '1px solid rgba(255,255,255,0.08)',
    }}>
      <div style={{ fontSize: 20, fontWeight: 700, color }}>{value}</div>
      <div style={{ fontSize: 11, color: '#888' }}>{label}</div>
    </div>
  )
}
